import Vue from 'vue';
import Vuex from 'vuex';
import Player from './modules/Player';
import Api from './modules/Api';
import User from './modules/User';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  state: {
    authenticate: false,
    splashscreen: false,
  },
  getters: {
    ready: state => state.authenticate && state.splashscreen,
    authenticate: state => state.authenticate,
    splashscreen: state => state.splashscreen,
  },
  mutations: {
    isAuthenticate(state) {
      state.authenticate = true;
    },
    isSplashcreen(state) {
      state.splashscreen = true;
    },
  },
  modules: {
    Player,
    Api,
    User,
  },
  strict: debug,
  plugins: debug ? [] : [],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js